/**
 * Print a server-rendered page without opening a new browser tab.
 */
const PrintService = {
    print(url) {
        if (!url) {
            return;
        }

        const existing = document.getElementById('vl-silent-print-frame');
        if (existing) {
            existing.remove();
        }

        const iframe = document.createElement('iframe');
        iframe.id = 'vl-silent-print-frame';
        iframe.setAttribute('aria-hidden', 'true');
        iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;opacity:0;pointer-events:none;';
        iframe.src = url;

        let cleaned = false;
        const cleanup = () => {
            if (cleaned) {
                return;
            }
            cleaned = true;
            setTimeout(() => {
                if (iframe.parentNode) {
                    iframe.parentNode.removeChild(iframe);
                }
            }, 500);
        };

        const waitForImages = (doc) => {
            const images = Array.from(doc.images || []);
            if (!images.length) {
                return Promise.resolve();
            }
            return Promise.all(
                images.map((img) => {
                    if (img.complete) {
                        return Promise.resolve();
                    }
                    return new Promise((resolve) => {
                        img.addEventListener('load', resolve, { once: true });
                        img.addEventListener('error', resolve, { once: true });
                    });
                })
            );
        };

        iframe.onload = () => {
            try {
                const win = iframe.contentWindow;
                const doc = iframe.contentDocument;
                if (!win || typeof win.print !== 'function' || !doc) {
                    cleanup();
                    return;
                }

                const onAfterPrint = () => {
                    win.removeEventListener('afterprint', onAfterPrint);
                    cleanup();
                };
                win.addEventListener('afterprint', onAfterPrint);

                waitForImages(doc).then(() => {
                    setTimeout(() => {
                        try {
                            win.focus();
                            win.print();
                        } catch (e) {
                            cleanup();
                            return;
                        }
                        // Fallback if afterprint never fires in some browsers
                        setTimeout(cleanup, 60000);
                    }, 250);
                });
            } catch (e) {
                cleanup();
            }
        };

        document.body.appendChild(iframe);
    }
};

export default PrintService;
